/*
* Builds a 'no data object' - an object where the label is set to show 'No data' and the value is null
* Used in autocomplete input fields when no results match the query and thus no data is returned from the API
* @param {String} activeElement
* @return Object
*/
export default (activeElement) => {
  let noDataObj = { label: 'No data' }
  noDataObj[activeElement] = null
  return noDataObj
}
